import { ILayout, ITeacherSize } from '@/core/interfaces/presentation-mode-status.interface';
import { Store } from '@/core/store/core.store';
import { MEETINGS_STORE } from '../store/meetings.store';
import WebSocketMessageResponse from '@/content/models/web-socket-message-response.model';

export class MeetingsStoreFacade {

  updatePresentationModeLayoutInfo(layoutInfo: ILayout): void {
    Store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_PRESENTATION_MODE_LAYOUT_INFO, layoutInfo);
  }

  updateCurrentBoardUser(userData: { [key: string]: any }): void {
    Store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_CURRENT_BOARD_USER, userData);
  }

  updatePresentationModePageSizeInfo(pageSizeInfo: ITeacherSize): void {
    Store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_PRESENTATION_MODE_PAGE_INFO, pageSizeInfo);
  }

  updateWhiteboardTransparency(isWhiteboardTransparency: boolean): void {
    Store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_WHITEBOARD_TRANSPARENCY, isWhiteboardTransparency);
  }

  updatePresentationModeViewerType(viewerType: string): void {
    Store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_PRESENTATION_MODE_VIEWER_TYPE, viewerType);
  }

  updateMultiplePresentationModeViewerTypes(viewerTypes: string[]): void {
    Store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_MULTIPLE_PRESENTATION_MODE_VIEWER_TYPES, viewerTypes);
  }

  updateInitialPresentationModeMessage(message: WebSocketMessageResponse): void {
    Store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_INITIAL_PRESENTATION_MODE_MESSAGE, message);
  }

  updateCurrentPresentationSection(currentSection: any): void {
    Store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_CURRENT_PRESENTATION_SECTION, currentSection);
  }

  addCurrentPageSizes(data: any): void {
    Store.commit(MEETINGS_STORE.MUTATIONS.ADD_CURRENT_PAGE_SIZES, data);
  }

  updatePresentationModeScrollInfo(data: any): void {
    Store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_PRESENTATION_MODE_SCROLL_INFO, data);
  }

  updateTransparentBoardPath(path: string) {
    Store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_TRANSPARENT_BOARD_PATH, path);
  }

  addCurrentMeetingActiveUser(user: string) {
    Store.commit(MEETINGS_STORE.MUTATIONS.ADD_CURRENT_MEETING_ACTIVE_USER, user);
  }

  removeCurrentMeetingActiveUser(user: string) {
    Store.commit(MEETINGS_STORE.MUTATIONS.REMOVE_CURRENT_MEETING_ACTIVE_USER, user);
  }

  removeCurrentMeetingUsers() {
    Store.commit(MEETINGS_STORE.MUTATIONS.REMOVE_CURRENT_MEETING_USERS);
  }

  clearCurrentMeetingActiveUsers() {
    Store.commit(MEETINGS_STORE.MUTATIONS.CLEAR_CURRENT_MEETING_ACTIVE_USERS);
  }

  setShareTaskData(data: { [key: string]: any }) {
    Store.commit(MEETINGS_STORE.MUTATIONS.SET_SHARE_TASK_DATA, data);
  }

  updateOriginalPagesSize(pageSize: any) {
    Store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_ORIGINAL_PAGES_SIZE, pageSize);
  }

  updateLoadedBoardsInDom(count: number) {
    Store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_LOADED_BOARDS_IN_DOM, count);
  }

  async obtainMeetingUsers(roomId: number) {
    return Store.dispatch(MEETINGS_STORE.ACTIONS.OBTAIN_MEETING_USERS, roomId)
  }
}
